import {
  Component,
  OnInit,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild,
  ElementRef,
  ViewChildren,
  OnChanges,
} from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { SupportService } from "../../services/support-service";
import { Location } from "@angular/common";
import { AppService } from "../../services/app.service";
import { FormBuilder, FormGroup, Validators, FormArray } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { FormControl } from "@angular/forms";
import { Router } from "@angular/router";

@Component({
  selector: "app-grid-with-filter-and-pagination",
  templateUrl: "./grid-with-filter-and-pagination.component.html",
  styleUrls: ["./grid-with-filter-and-pagination.component.scss"],
})
export class GridWithFilterAndPaginationComponent implements OnInit, OnChanges {
  @Input() public rows: Array<any> = [];

  @Input() public columns: Array<any> = [];

  @Input() public fullView = true;
  @Input() public modalName: string;
  @Input() public configOptions: string;
  @ViewChildren("template, templateReview,template1,physicianTemplate")
  templates;
  physicianForm: FormGroup;
  testCountryCode = "";
  countryList: any;
  tcCode: any;
  stateList: any;
  physicianFaxMask = "";
  physicianPhoneMask = "";
  secondaryInfoPhoneMask = "";
  modalRef: BsModalRef;
  tdOrder = "";
  tdValue = "";
  routerName = "";
  fullInfo: any;
  doctorInfo: any;
  insInfo: any;
  physicianFullInfo: any;
  visitHistory: any;
  rowData: any = {};
  printId: any;
  pagenumber = 1;
  pagesize = 10;
  searchText = "";
  searchPatient = "";
  physicianSavebutton = false;
  physiciansubmit = false;
  doctorsCount = 0;
  physicianId = "";
  firstNameControl = new FormControl();

  constructor(
    private modalService: BsModalService,
    private location: Location,
    private toastr: ToastrService,
    private supportService: SupportService,
    private appService: AppService,
    private formBuilder: FormBuilder,
    private router: Router
  ) {}

  pageChanged(event) {
    this.pagenumber = event.page;
  }
  ngOnInit() {
    this.PhysicianForm();
    if (localStorage.getItem("countryId") != null) {
      this.testCountryCode = localStorage.getItem("countryId");
      this.getStateList(localStorage.getItem("countryId"));
    }

    this.checkUrl();
    this.getcountry();
  }
  checkUrl() {
    const path = this.location.path().split("/");
    if (path.length === 3) {
      this.routerName = path[2];
    }
  }

  updateAmount(id,amount){
    console.log("amount");
    console.log(id,amount);
    var data = {
      "id":id,
      "amount":amount
    }
    this.appService.updateAppointmentAmount(data).subscribe(res=>{
      console.log(res);
      if(res["status"] && (res["status"]["status"] === '200' || res["status"]["status"] === 200)){
        this.toastr.success("Amount updated");
      }
    })
  }
  getcountry() {
    this.appService.getCountry().subscribe(
      (res) => {
        if (res && res["entity"]) {
          this.countryList = res["entity"];
        } else {
          this.countryList = [];
        }
      },
      (err) => {
        this.appService.sessionOut(err);
      }
    );
  }

  changeCountry(countryid, stateid) {
    if (countryid && countryid > 0) {
      this.physicianForm.controls["physicianState"].setValue("default");
      this.getStateList(countryid);

      if (countryid === "101" || countryid === 101) {
        this.physicianForm.controls["physicianState"].setValue("default");
        this.getStateList(countryid);
        this.physicianForm.controls["physicianPhoneCode"].setValue("+91");
        this.physicianPhoneMask = "00000-00000";
        this.physicianForm.controls.physicianPhone.enable();
        this.physicianForm.controls["physicianFaxCode"].setValue("+91");
        this.physicianFaxMask = "00000-00000";
        this.physicianForm.controls["physicianFaxMask"].setValue(
          this.physicianFaxMask
        );
        this.physicianForm.controls["physicianPhoneMask"].setValue(
          this.physicianPhoneMask
        );

        this.physicianForm.controls.physicianFax.enable();
      } else if (countryid === "231" || countryid === 231) {
        this.physicianForm.controls["physicianState"].setValue("default");
        this.getStateList(countryid);
        this.physicianForm.controls["physicianPhoneCode"].setValue("+1");
        this.physicianPhoneMask = "(000) 000-0000";
        this.physicianForm.controls["physicianPhoneMask"].setValue(
          this.physicianPhoneMask
        );

        this.physicianForm.controls.physicianPhone.enable();
        this.physicianForm.controls["physicianFaxCode"].setValue("+1");
        this.physicianFaxMask = "(000) 000-0000";
        this.physicianForm.controls["physicianFaxMask"].setValue(
          this.physicianFaxMask
        );

        this.physicianForm.controls.physicianFax.enable();
      }
      this.getStateList(countryid);
      this.physicianForm.controls["physicianState"].setValue("default");
    }
  }

  updatePhysicinfo() {
    this.physicianSavebutton = true;
    this.physiciansubmit = true;
    if (this.physicianForm.valid && this.physicianForm.status === "VALID") {
      this.physiciansubmit = false;
      const data = {
        id: this.physicianForm.controls["physicianId"]["value"],
        firstName: this.physicianForm.controls["physicianFirstName"]["value"],
        lastName: this.physicianForm.controls["physicianLastName"]["value"],
        physicianContactFirstName: this.physicianForm.controls[
          "physicianContactFirstName"
        ]["value"],
        physicianContactLastName: this.physicianForm.controls[
          "physicianContactLastName"
        ]["value"],
        address: {
          street: "",
          addressLine1: this.physicianForm.controls["physicianAddressLine1"][
            "value"
          ],
          addressLine2: this.physicianForm.controls["physicianAddressLine2"][
            "value"
          ],
          cityName: this.physicianForm.controls["physicianCity"]["value"],
          zipCode: this.physicianForm.controls["physicianZipcode"]["value"],
          areaName: "",
          state: {
            id:
              this.physicianForm.controls["physicianState"]["value"] !==
              "default"
                ? this.physicianForm.controls["physicianState"]["value"]
                : "",
          },
          country: {
            id: this.physicianForm.controls["physicianCountry"]["value"],
          },
        },
        physicianPhoneCode: this.physicianForm.controls["physicianPhoneCode"][
          "value"
        ],
        physicianPhone: this.physicianForm.controls["physicianPhone"]["value"],
        physicianFax: this.physicianForm.controls["physicianFax"]["value"],
        physicianFaxCode: this.physicianForm.controls["physicianFaxCode"][
          "value"
        ],
        dpi: this.physicianForm.controls["dpinumber"]["value"],
        taxId: this.physicianForm.controls["taxid"]["value"],
      };
      this.appService.update(data).subscribe(
        (res) => {
          if (res && res["status"] && res["status"]["status"] === 200) {
            this.modalRef.hide();
            this.supportService.physicianpage.next("");
            this.toastr.success("Updated successfully");
            setTimeout(() => {}, 5000);
            this.modalRef.hide();
          }
          this.physicianSavebutton = false;
        },
        (err) => {
          this.appService.sessionOut(err);
          this.physicianSavebutton = false;
        }
      );
    } else {
      this.physicianSavebutton = false;
    }
  }

  getStateList(countryid) {
    this.appService.getState(countryid).subscribe(
      (res) => {
        this.stateList = res["entity"];
      },
      (err) => {
        this.appService.sessionOut(err);
      }
    );
  }

  PhysicianForm() {
    this.physicianForm = this.formBuilder.group({
      physicianId: [""],
      physicianFirstName: ["", Validators.required],
      physicianLastName: ["", Validators.required],
      physicianContactFirstName: [""],
      physicianContactLastName: [""],
      physicianPhoneCode: [""],
      physicianPhoneMask: [""],
      physicianPhone: ["", [Validators.required, Validators.minLength(10)]],
      physicianFaxCode: [""],
      physicianFax: ["", [Validators.required, Validators.minLength(10)]],
      physicianFaxMask: [""],
      physicianAddressLine1: [""],
      physicianAddressLine2: [""],
      physicianCity: [""],
      physicianZipcode:[""],
      physicianState: [""],
      physicianCountry: [""],
      dpinumber: [""],
      taxid: [""],
    });
  }

  changeMask(type, value) {
    if (type === "physicianPhoneMask") {
      if (value === "+91" || value === +91) {
        this.physicianPhoneMask = "00000-00000";
        this.physicianForm.controls["physicianPhoneMask"].setValue(
          this.physicianPhoneMask
        );
      } else if (value === "+1" || value === +1) {
        this.physicianPhoneMask = "(000) 000-0000";
        this.physicianForm.controls["physicianPhoneMask"].setValue(
          this.physicianPhoneMask
        );
      }
    }

    if (type === "physicianFaxMask") {
      if (value === "+91" || value === +91) {
        this.physicianFaxMask = "00000-00000";
        this.physicianForm.controls["physicianFaxMask"].setValue(
          this.physicianFaxMask
        );
      } else if (value === "+1" || value === +1) {
        this.physicianFaxMask = "(000) 000-0000";
        this.physicianForm.controls["physicianFaxMask"].setValue(
          this.physicianFaxMask
        );
      }
    }
  }

  deleteICHistory(obj, i) {
    if (obj && obj.param9) {
      this.appService
        .deleteCancelScheduleBytype(obj.param9)
        .subscribe((res) => {
          if (res["status"] && res["status"]["status"] === 200) {
            this.columns.splice(i, 1);
            this.toastr.success("Deleted successfully");
          }
        });
    }
  }

  closepop() {
    this.physicianSavebutton = false;
    this.modalRef.hide();
  }

  openModal(template: TemplateRef<any>, id, patientId, physicianId, column) {
    let data;
    this.physicianSavebutton = false;
    if (this.fullView === true) {
      this.PhysicianForm();
      this.rowData = column;
      this.fullInfo = "";
      this.doctorInfo = "";
      if (id && patientId) {
        this.appService
          .viewscheduleappointmentwithcheckin(
            id,
            patientId,
            localStorage.getItem("testCenterId")
          )
          .subscribe((res) => {
            if (res && res["status"] && res["status"]["status"] === 200) {
              if (res["entity"]) {
                this.fullInfo = res["entity"];
              }
            }
          });
      }

      if (patientId) {
        this.appService
          .getschedinsurancelistbytype(
            patientId,
            localStorage.getItem("testCenterId"),
            "patient"
          )
          .subscribe((res) => {
            if (res && res["status"] && res["status"]["status"] === 200) {
              if (res["entity"]) {
                this.insInfo = res["entity"];
              }
            }
          });
      }
      if (physicianId) {
        this.physicianId = physicianId;
        this.getpatients(1);
      }

      if (physicianId) {
        this.appService.viewphysicianbyid(physicianId).subscribe((res) => {
          if (res && res["status"] && res["status"]["status"] === 200) {
            if (res["entity"]) {
              this.physicianFullInfo = res["entity"];
              if (this.physicianFullInfo) {
                setTimeout(() => {
                  this.physicianForm.controls.physicianId.setValue(
                    this.physicianFullInfo.id
                  );
                  this.physicianForm.controls.physicianLastName.setValue(
                    this.physicianFullInfo.lastName
                  );
                  this.physicianForm.controls.physicianFirstName.setValue(
                    this.physicianFullInfo.firstName
                  );
                  this.physicianForm.controls.physicianContactFirstName.setValue(
                    this.physicianFullInfo.physicianContactFirstName
                  );
                  this.physicianForm.controls.physicianContactLastName.setValue(
                    this.physicianFullInfo.physicianContactLastName
                  );
                  this.physicianForm.controls.physicianPhoneCode.setValue(
                    this.physicianFullInfo.physicianPhoneCode
                      ? this.physicianFullInfo.physicianPhoneCode
                      : this.testCountryCode === "231"
                      ? "+1"
                      : "+91"
                  );
                  this.changeMask(
                    "physicianPhoneMask",
                    this.physicianForm.controls["physicianPhoneCode"]["value"]
                  );
                  this.physicianForm.controls.physicianPhone.setValue(
                    this.physicianFullInfo.physicianPhone
                  );
                  this.physicianForm.controls.physicianFaxCode.setValue(
                    this.physicianFullInfo.physicianFaxCode
                      ? this.physicianFullInfo.physicianFaxCode
                      : this.testCountryCode === "231"
                      ? "+1"
                      : "+91"
                  );
                  this.changeMask(
                    "physicianFaxMask",
                    this.physicianForm.controls["physicianFaxCode"]["value"]
                  );
                  this.physicianForm.controls.physicianFax.setValue(
                    this.physicianFullInfo.physicianFax
                  );
                  if (
                    this.physicianFullInfo &&
                    this.physicianFullInfo.address != null &&
                    this.physicianFullInfo.address.country &&
                    this.physicianFullInfo.address.country.id
                  ) {
                    this.physicianForm.controls.physicianAddressLine1.setValue(
                      this.physicianFullInfo.address.addressLine1
                    );
                    this.physicianForm.controls.physicianAddressLine2.setValue(
                      this.physicianFullInfo.address.addressLine2
                    );
                    this.physicianForm.controls.physicianCity.setValue(
                      this.physicianFullInfo.address.cityName
                    );
                    this.physicianForm.controls.physicianZipcode.setValue(
                      this.physicianFullInfo.address.zipCode
                    );
                    this.physicianForm.controls.physicianState.setValue(
                      this.physicianFullInfo.address.state != null
                        ? this.physicianFullInfo.address.state.id
                        : "default"
                    );
                    this.physicianForm.controls.physicianCountry.setValue(
                      this.physicianFullInfo.address.country.id
                    );
                    this.getStateList(
                      this.physicianFullInfo.address.country.id
                    );
                  } else {
                    this.physicianForm.controls.physicianState.setValue(
                      "default"
                    );
                    this.physicianForm.controls.physicianCountry.setValue(
                      this.testCountryCode
                    );
                    this.getStateList(this.testCountryCode);
                  }
                }, 700);
              }
            } else {
              this.physicianFullInfo = "";
            }
          } else {
            this.physicianFullInfo = "";
          }
        });
      }

      if (patientId) {
        data = {
          patientId: patientId,
          tcId: localStorage.getItem("testCenterId"),
          type: "all",
        };
        this.visitHistory = [];
        this.appService.getVisitingHistory(data).subscribe((res) => {
          if (res && res["status"] && res["status"]["status"] == 200) {
            if (res["entity"]) {
              this.visitHistory = res["entity"];
            }
          }
        });
      }

      let template;
      this.templates.forEach((ele) => {
        if (ele && ele["_def"] && ele["_def"]["references"]) {
          const tmpref = Object.keys(
            ele["_def"] && ele["_def"]["references"]
          )[0];
          if (tmpref === this.modalName) {
            template = ele;
          }
        }
      });
      if (this.modalName && this.modalName === "templateReview") {
        this.modalRef = this.modalService.show(
          template,
          Object.assign({ class: "modal-md" })
        );
      } else {
        this.modalRef = this.modalService.show(
          template,
          Object.assign({ class: "modal-xl" })
        );
      }
    } else {
      this.tcCode = localStorage.getItem("testCode");
      if (column.param8 === "imaging") {
        this.router.navigate([this.tcCode + "/basicinfo"]);
        sessionStorage.setItem("testId", column.param7);
      }

      if (column.param5 === "technologist") {
        this.router.navigate([this.tcCode + "/technician"]);
        sessionStorage.setItem("techiedit", "true");
        sessionStorage.setItem("techieId", column.param6);
      }
      if (column.param7 === "patient-list") {
        this.router.navigate([this.tcCode + "/patient-edit"]);
        sessionStorage.setItem("patientId", column.param6);
      }
    }
  }

  navigateToImagingCenter(tcId, tcName) {
    if (tcId && tcId !== "-") {
      this.tcCode = localStorage.getItem("testCode") || "admin";
      this.router.navigate([this.tcCode + "/basicinfo"]);
      sessionStorage.setItem("testId", tcId);
    }
  }

  getpatients(event) {
    const data = {
      physicianId: this.physicianId,
      pagenumber: event,
      pagesize: this.pagesize,
      search: this.searchPatient,
    };
    this.appService.getpatientsbyphysicianid(data).subscribe((res) => {
      if (res && res["status"] && res["status"]["status"] === 200) {
        if (res["entity"]) {
          this.doctorInfo = res["entity"];
          this.doctorsCount = res["count"];
        }
      }
    });
  }

  refreshPatient() {
    this.searchText = "";
    this.searchPatient = "";
    this.getpatients(this.pagenumber);
  }

  onBlurSearchMethod() {
    this.searchPatient = this.searchText;
    this.pagenumber = 1;
    this.getpatients(this.pagenumber);
  }

  gridSorting(value, order, gridNo) {
    this.tdValue = value;
    this.tdOrder = order;
    let number;
    if (gridNo) {
      number = gridNo;
    } else {
      number = "";
    }
    const data = {
      name: value,
      order: order,
      routerName: this.routerName,
      girdNo: number,
    };
    this.supportService.gridSortingHeader.next(data);
  }
  ngOnChanges() {
    this.printId =
      this.configOptions && this.configOptions["id"]
        ? this.configOptions["id"]
        : "";
  }
}
